import { render, staticRenderFns } from "./InterfaceConfigurationList.vue?vue&type=template&id=f684a36a&"
import script from "./InterfaceConfigurationList.vue?vue&type=script&lang=js&"
export * from "./InterfaceConfigurationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports